import Vue from "vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";

Vue.use(BootstrapVue, {
  BToast: { toaster: "b-toaster-top-center" },
});
Vue.use(BootstrapVueIcons);
